(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_contact-form"] && !Shopify.designMode) return;
  try {
    function focusContactFormSuccess() {
    var success = document.querySelector('[data-contact-form-success]');

    if (success) {
      success.focus();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', focusContactFormSuccess);
  } else {
    focusContactFormSuccess();
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_content-doorway"] && !Shopify.designMode) return;
  try {
    class ContentDoorway extends HTMLElement {
    #blocksObserver = null;
    #regroupFrame = null;
    #isGrouping = false;

    connectedCallback() {
      const blocks = this.querySelector('.content-doorway__blocks');
      if (!blocks) return;

      this.#groupOverlayBlocks();
      this.#blocksObserver = new MutationObserver(() =>
        this.#scheduleRegroup(),
      );
      this.#blocksObserver.observe(blocks, { childList: true });
    }

    disconnectedCallback() {
      this.#blocksObserver?.disconnect();
      this.#blocksObserver = null;

      if (this.#regroupFrame) {
        cancelAnimationFrame(this.#regroupFrame);
        this.#regroupFrame = null;
      }
    }

    #scheduleRegroup() {
      if (this.#isGrouping) return;

      if (this.#regroupFrame) {
        cancelAnimationFrame(this.#regroupFrame);
      }

      this.#regroupFrame = requestAnimationFrame(() => {
        this.#regroupFrame = null;
        this.#groupOverlayBlocks();
      });
    }

    #groupOverlayBlocks() {
      const blocks = this.querySelector('.content-doorway__blocks');
      if (!blocks) return;

      this.#isGrouping = true;
      this.#blocksObserver?.disconnect();

      const existingSticky = blocks.querySelector(
        ':scope > .content-doorway__sticky',
      );
      if (existingSticky) {
        while (existingSticky.firstElementChild) {
          blocks.insertBefore(existingSticky.firstElementChild, existingSticky);
        }
        existingSticky.remove();
      }

      const sticky = document.createElement('div');
      sticky.className = 'content-doorway__sticky';

      for (const child of [...blocks.children]) {
        if (child.classList.contains('content-doorway__overlay')) continue;
        if (child.querySelector('.media-block')) continue;
        sticky.appendChild(child);
      }

      if (sticky.childElementCount > 0) {
        blocks.appendChild(sticky);
      }

      this.#blocksObserver?.observe(blocks, { childList: true });
      this.#isGrouping = false;
    }
  }

  if (!customElements.get('content-doorway')) {
    customElements.define('content-doorway', ContentDoorway);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_product-feature-usps"] && !Shopify.designMode) return;
  try {
    (() => {
    const NAME = 'product-feature-usps';

    class ProductFeatureUsps extends HTMLElement {
      #boundVariantChange = null;
      #fallbackUsps = [];
      #variantUsps = {};

      connectedCallback() {
        try {
          this.#fallbackUsps = JSON.parse(this.dataset.fallbackUsps || '[]');
        } catch (error) {
          this.#fallbackUsps = [];
        }

        try {
          this.#variantUsps = JSON.parse(this.dataset.variantUsps || '{}');
        } catch (error) {
          this.#variantUsps = {};
        }

        this.#boundVariantChange = (event) => this.#onVariantChange(event);
        document.addEventListener('variant:change', this.#boundVariantChange);
        this.#syncFromSelectedVariant();
      }

      disconnectedCallback() {
        document.removeEventListener(
          'variant:change',
          this.#boundVariantChange,
        );
      }

      #selectedVariantId() {
        const scope =
          this.closest('product-form') ||
          this.closest('.product') ||
          this.closest('form');
        const variantInput = scope?.querySelector('[data-variant-input]');

        if (variantInput?.value) {
          return Number(variantInput.value);
        }

        return null;
      }

      #uspsForVariant(variantId) {
        if (variantId == null) {
          return this.#fallbackUsps;
        }

        const key = String(variantId);

        if (Object.prototype.hasOwnProperty.call(this.#variantUsps, key)) {
          const usps = this.#variantUsps[key];

          // Empty override (cleared / invalid rows) falls through to product /
          // colour-group USPs — same chain as the Liquid SSR path.
          if (Array.isArray(usps) && usps.length > 0) {
            return usps;
          }
        }

        return this.#fallbackUsps;
      }

      #syncFromSelectedVariant() {
        this.#renderUsps(this.#uspsForVariant(this.#selectedVariantId()));
      }

      #onVariantChange(event) {
        const variant = event.detail?.variant;
        const eventProductId = event.detail?.product?.id;

        if (!variant?.id) return;

        if (
          this.dataset.productId &&
          eventProductId != null &&
          Number(eventProductId) !== Number(this.dataset.productId)
        ) {
          return;
        }

        this.#renderUsps(this.#uspsForVariant(variant.id));
      }

      #fallbackIconNode() {
        const template = this.querySelector('[data-fallback-icon]');
        const content = template?.content?.firstElementChild;

        if (!content) return null;

        return content.cloneNode(true);
      }

      #renderUsps(usps) {
        const list = this.querySelector('[data-usp-list]');

        if (!list) return;

        list.replaceChildren();

        if (!Array.isArray(usps) || usps.length === 0) {
          this.hidden = true;
          return;
        }

        const fragment = document.createDocumentFragment();

        for (const usp of usps) {
          const label = usp?.label;

          if (!label) continue;

          const item = document.createElement('li');
          item.className = 'product-feature-usps__item';

          const iconWrap = document.createElement('span');
          iconWrap.className = 'product-feature-usps__icon-wrap';
          iconWrap.setAttribute('aria-hidden', 'true');

          if (usp.iconUrl) {
            const img = document.createElement('img');
            img.className = 'product-feature-usps__icon';
            img.src = usp.iconUrl;
            img.width = 32;
            img.height = 32;
            img.loading = 'lazy';
            img.alt = '';
            iconWrap.append(img);
          } else {
            const fallbackIcon = this.#fallbackIconNode();

            if (fallbackIcon) {
              iconWrap.append(fallbackIcon);
            }
          }

          item.append(iconWrap);

          const labelEl = document.createElement('span');
          labelEl.className = 'product-feature-usps__label font-body-sm--bold';
          labelEl.textContent = label;
          item.append(labelEl);
          fragment.append(item);
        }

        if (!fragment.childNodes.length) {
          this.hidden = true;
          return;
        }

        list.append(fragment);
        this.hidden = false;
      }
    }

    if (!customElements.get(NAME)) {
      customElements.define(NAME, ProductFeatureUsps);
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["card-price"] && !Shopify.designMode) return;
  try {
    (() => {
    const LINK_SELECTOR = '.card-price__reviews';
    const SETTLE_MS = 2500;

    /*
     * The reviews section is the last one on the product page, and the sections
     * above it (video, model blocks, recommendations, FAQ) reserve no height
     * until their media and scripts hydrate. A jump taken before that settles
     * lands against a document that then grows underneath the target, leaving
     * the shopper back up near the buy box. Re-assert the target while the page
     * height is still changing, and bail out the moment they scroll themselves.
     */
    const holdTargetInView = (target) => {
      const start = performance.now();
      const listenerOptions = { passive: true, once: true };

      let lastHeight = document.documentElement.scrollHeight;
      let cancelled = false;

      const cancel = () => {
        cancelled = true;
      };

      window.addEventListener('wheel', cancel, listenerOptions);
      window.addEventListener('touchstart', cancel, listenerOptions);
      window.addEventListener('keydown', cancel, listenerOptions);

      const tick = () => {
        if (cancelled) return;

        const height = document.documentElement.scrollHeight;

        if (height !== lastHeight) {
          lastHeight = height;
          target.scrollIntoView({ behavior: 'auto', block: 'start' });
        }

        if (performance.now() - start < SETTLE_MS) {
          window.requestAnimationFrame(tick);
          return;
        }

        window.removeEventListener('wheel', cancel);
        window.removeEventListener('touchstart', cancel);
        window.removeEventListener('keydown', cancel);
      };

      window.requestAnimationFrame(tick);
    };

    document.addEventListener('click', (event) => {
      const link = event.target.closest(LINK_SELECTOR);

      if (!link) return;

      const href = link.getAttribute('href') || '';

      if (!href.startsWith('#')) return;

      const target = document.getElementById(href.slice(1));

      if (!target) return;

      event.preventDefault();

      /*
       * replaceState rather than a new history entry: a hash entry makes Back
       * fire popstate, which the colourway swatches read as a request to
       * re-render the whole product.
       */
      window.history.replaceState(window.history.state, '', href);
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      holdTargetInView(target);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["section-text"] && !Shopify.designMode) return;
  try {
    (() => {
    const ELEMENT_NAME = 'read-more-text';

    if (customElements.get(ELEMENT_NAME)) return;

    class ReadMoreText extends HTMLElement {
      #toggle = null;
      #boundOnClick = this.#onClick.bind(this);

      connectedCallback() {
        this.#toggle = this.querySelector('.section-text__toggle');
        if (!this.#toggle) return;

        this.classList.add('section-text--enhanced');
        this.#setExpanded(false);
        this.#toggle.addEventListener('click', this.#boundOnClick);
      }

      disconnectedCallback() {
        this.#toggle?.removeEventListener('click', this.#boundOnClick);
      }

      #onClick() {
        this.#setExpanded(this.dataset.expanded !== 'true');
      }

      #setExpanded(expanded) {
        this.dataset.expanded = expanded ? 'true' : 'false';
        this.#toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
        this.#toggle.textContent = expanded
          ? this.#toggle.dataset.labelLess
          : this.#toggle.dataset.labelMore;
      }
    }

    customElements.define(ELEMENT_NAME, ReadMoreText);
  })();
  } catch(e) { console.error(e); }
})();

})();
